enum ClientStatus {
	ACTIVE = "active",
	INACTIVE = "inactive",
	DEPRECATED = "deprecated",
}

export { ClientStatus };
